export default {"src":"/_next/static/media/planeswalker.0b5fbf4c.svg","height":1204,"width":600,"blurWidth":0,"blurHeight":0};